import type { ViewContainerRef } from '@angular/core';
import { Injectable, inject } from '@angular/core';

import type { IntegrationKinds } from '@core/integrations-types';
import { DialogService, DialogWidth } from '@core/user-interface-legacy';

type ConnectConfig = {
  integrationKind: IntegrationKinds;
  redirectUrl?: string;
  vcRef: ViewContainerRef;
};

@Injectable({ providedIn: 'root' })
export class OAuthService {
  private readonly dialogService = inject(DialogService);

  public async connect(config: ConnectConfig) {
    const { OAuthCredentializeDialogComponent } =
      await import('./oauth-credentialize-dialog/oauth-credentialize-dialog.component');
    const redirectUrl = config.redirectUrl || window.location.href;

    this.dialogService.openCustom(
      OAuthCredentializeDialogComponent,
      { width: DialogWidth.SmallXX },
      { redirectUrl, integrationKind: config.integrationKind },
      config.vcRef,
    );
  }
}
